import React from 'react'
import TextFieldMui from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import getRandomId from '@/v2/utils/random-id'
import Label from '@/v2/components/common/FieldLabel'
import Typography from '@/v2/components/common/Typography'

const SelectField = ({
  fullWidth,
  group,
  label,
  name,
  placeholder,
  error,
  warning,
  options,
  noMargin,
  onChange,
  outlineColor,
  ...others
}) => {
  const id = getRandomId()

  return (
    <FormControl
      sx={{ mb: noMargin ? '0px' : '23px' }}
      variant="standard"
      fullWidth={fullWidth}
    >
      {label && <Label htmlFor={id}>{label}</Label>}
      <TextFieldMui
        select
        id={id}
        name={name}
        SelectProps={{ native: true }}
        onChange={event => onChange && onChange(event.target.value)}
        sx={{
          ...(outlineColor && {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: outlineColor,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: others.disabled
                ? 'rgba(0, 0, 0, 0.23)'
                : outlineColor,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: outlineColor,
            },
          }),
        }}
        {...others}
      >
        {placeholder && (
          <option aria-label={placeholder} value="">
            {placeholder}
          </option>
        )}
        {group
          ? options.map(
              group =>
                group.options.length > 0 && (
                  <optgroup key={group.label} label={group.label}>
                    {group.options.map(({ label, value }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </optgroup>
                )
            )
          : options.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
      </TextFieldMui>
      {error && <Typography variant="error">{error}</Typography>}
      {warning && <Typography variant="warning">{warning}</Typography>}
    </FormControl>
  )
}

export default SelectField
